import script from "./BannerSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerSettings.vue?vue&type=script&setup=true&lang=js"

import "./BannerSettings.vue?vue&type=style&index=0&id=a749ccca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a749ccca"]])

export default __exports__